import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA2g_95xbN1KOP4JWUgfZR3_P8FNEfPnrU",
  authDomain: "e-legislacao.firebaseapp.com",
  databaseURL: "https://e-legislacao-default-rtdb.firebaseio.com",
  projectId: "e-legislacao",
  storageBucket: "e-legislacao.appspot.com",
  messagingSenderId: "651879717751",
  appId: "1:651879717751:web:b0fd3bafff5140fee9df72",
  measurementId: "G-T40QZYQD1R",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage };
